<template>
  <v-container class="max-container">
        <v-row>
            <v-col xs="12" sm="12" md="12" lg="12" class="flex-col-center">
                <h1> Já está cadastrado? </h1>
                <h4> Nós achamos uma conta cadastrada com o número {{ user.phone }}. Ela é sua? </h4>
                <h4 class="mg-t-h4"> <v-icon> mdi-email-outline </v-icon> E-mail: {{user.email}} </h4>
            </v-col>
        </v-row>

        <div class="margin-top-divider-30" />

        <v-row class="flex-col-center">
            <v-col xs="12" sm="12" md="12" lg="12" class="w-100" :class="!mobileVersion? 'flex-row-center':'flex-col-center'">
                <v-btn color="var(--cor--roza)" outlined class="custom-btn" :class="mobileVersion? 'btn__mg-b--mobile':''" @click="redirectToTelefoneScreen()">
                    <span class="text-none text-bold"> Trocar de telefone </span>
                </v-btn>

                 <v-btn :color="currentCompany.buttonsColor" class="custom-btn w-btn" :class="!mobileVersion? 'btn--left':''" @click="redirectToLogin()">
                    <span class="text-white text-none text-bold"> Fazer login </span>
                </v-btn>
            </v-col>
        </v-row>
  </v-container>
</template>

<script>
//Store
import { mapGetters, mapActions } from "vuex"

//Service
import { getEmailByCompanyIdAndTelephone } from "./service/phone-registration-found.service";

export default {
    name: 'PhoneRegistrationFound',
    computed: {
        ...mapGetters('signupStore', {
                signupUser: 'get_signup_user'
            }
        ),
        ...mapGetters('authenticateStore', {
                currentCompany: 'get_currentCompany'
            }
        )
    },
    data: () => ({
        mobileVersion: false,
        user: {
            phone: '',
            email: '*****@****.com'
        }
    }),
    created() {
        this.compareWidth()
        window.addEventListener("resize", this.compareWidth);
        this.setInfo()
    },
    destroyed() {
      this.RESET_SIGNUP_USER()
      this.SET_ACCESS_SIGNUP(false)
    },
    methods: {
      ...mapActions('signupStore', ['RESET_SIGNUP_USER', 'SET_ACCESS_SIGNUP']),
        compareWidth() {
            if( window.innerWidth <= 390 ) {
                this.mobileVersion = true
              
            } else this.mobileVersion = false
        },
        redirectToLogin() {
            this.$router.push( {path: '/login'} )
        }, 
        redirectToTelefoneScreen() {
            this.$router.push( {path: '/acessos'} )
        },
        setInfo(){
            this.signupUser.telephone != null ? this.user.phone = this.signupUser.telephone : this.user.phone = ''
            getEmailByCompanyIdAndTelephone(this.currentCompany.id, this.signupUser.telephone)
                .then( success => {
                        this.user.email = this.hideEmail(success.data.email)
                    })
                    .catch( error => {
                            this.btnLoading = false;
                            if (error != null) {
                                this.$toasted.show(error.message, { type: 'error' } )
                            }
                        }
                    )
            this.user.email
        },
        hideEmail(email){
            var maskedid = "";
            var index = email.lastIndexOf("@");
            var prefix = email.substring(0, index);
            var postfix = email.substring(index);

            var mask = prefix.split('').map(function(o, i) {
            if (i == 0 || i == (index - 1)) {
                return o;
            } else {
                return '*';
            }
            }).join('');

            maskedid = mask + postfix;

            return maskedid;
        }
    }
}
</script>

<style scoped>
.btn__mg-b--mobile{
    margin-bottom: 24px;
}
.w-btn {
    width: 170px;
}
.mg-t-h4 {
    margin-top: 8px;
}
</style>